import { DefaultTheme } from 'styled-components';

// Extend the DefaultTheme interface
declare module 'styled-components' {
  export interface DefaultTheme {
    colors: {
      primary: string;
      secondary: string;
      accent: string;
      background: string;
      text: string;
      lightText: string;
      darkText: string;
    };
    fonts: {
      main: string;
      heading: string;
    };
    breakpoints: {
      sm: string;
      md: string;
      lg: string;
      xl: string;
    };
  }
}

// Define the theme
const theme: DefaultTheme = {
  colors: {
    primary: '#FFFFFF',
    secondary: '#000000',
    accent: '#8840ff',
    background: '#000000',
    text: '#FFFFFF',
    lightText: 'rgba(255, 255, 255, 0.8)',
    darkText: '#333333'
  },
  fonts: {
    main: "'Helvetica Neue', Arial, sans-serif",
    heading: "'Helvetica Neue', Arial, sans-serif",
  },
  breakpoints: {
    sm: '576px',
    md: '768px',
    lg: '1024px',
    xl: '1200px',
  }
};

export default theme; 